export const elevatorNumber = {
  className: 'cls-7',
  d: 'm355.8271,125.4316c.4941.0518,1.0664,0,1.8457-.0781,1.3262-.1816,2.5742-.7275,3.5361-1.6377,1.1182-1.0137,1.9248-2.4961,2.2363-4.498h-.0781c-.9355,1.1436-2.2881,1.8203-3.9775,1.8203-3.042,0-4.9922-2.2881-4.9922-5.1748,0-3.1982,2.3135-6.0059,5.7715-6.0059s5.5908,2.8076,5.5908,7.124c0,3.7188-1.248,6.3184-2.9121,7.9307-1.3008,1.2734-3.0947,2.0537-4.9141,2.2617-.832.1299-1.5605.1562-2.1064.1299v-1.8721Zm.832-9.7236c0,2.1055,1.2744,3.5879,3.25,3.5879,1.5342,0,2.7305-.7539,3.3281-1.7686.1299-.208.208-.4678.208-.832,0-2.8857-1.0664-5.0957-3.458-5.0957-1.9502,0-3.3281,1.7158-3.3281,4.1084Z',
}

export const FLOOR_9_DATA = [
  {
    id: 'C058',
    status: 'available',
    floor: 9,
    building: 'A',
    apartmentNumber: 'C058',
    sceneName: 'scene_09krs_C058',
    sceneName_future: 'scene_09krs_C058_future',
    name: 'C058',
    label: 'C58',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-13',
      points:
        '174.1666 14.4776 174.1666 65.4725 240 65.4167 240 43.4938 222.5001 43.4763 222.5001 28.7222 229.6667 28.7222 229.6667 14.4226 174.1666 14.4776',
    },
    viewCone: {
      className: 'cls-10',
      pathData:
        'm193.6771,45.1599c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '190.9995',
      cy: '40.7134',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-11',
        d: 'm220.6699,57.5898c-.459.2236-1.0605.334-1.8008.334-.9668,0-1.7275-.2832-2.2812-.8516s-.8301-1.3262-.8301-2.2725c0-1.0078.3105-1.8252.9336-2.4521.6221-.627,1.4297-.9404,2.4238-.9404.6152,0,1.1328.0781,1.5547.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0684.1865-1.4316.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5137,1.4561.3428.3623.8047.543,1.3848.543.5527,0,1.0605-.1348,1.5195-.4043v1.2959Z',
      },
      {
        className: 'cls-11',
        d: 'm221.7695,57.6523v-1.1875c.4297.2637.8887.3965,1.375.3965.3662,0,.6523-.0879.8594-.2617.207-.1748.3096-.4111.3096-.71,0-.624-.4404-.9365-1.3232-.9365-.2871,0-.6338.0273-1.041.0801v-3.5205h3.4893v1.1338h-2.3027v1.2617c.1846-.0176.3584-.0273.5225-.0273.6484,0,1.1543.1709,1.5215.5098.3652.3408.5488.7979.5488,1.3711,0,.6367-.2188,1.1553-.6543,1.5586-.4375.4023-1.0293.6035-1.7754.6035-.6074,0-1.1172-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-11',
        d: 'm227.8555,54.541v-.0225c-.7207-.2959-1.0811-.7744-1.0811-1.4365,0-.4863.1934-.8877.5801-1.2021.3867-.3154.8857-.4727,1.499-.4727.623,0,1.1211.1475,1.4941.4414.3711.2949.5576.6748.5576,1.1406,0,.6885-.3984,1.1953-1.1953,1.5205v.0176c.4277.126.7588.333.9951.6221.2363.2881.3535.6123.3535.9736,0,.5566-.2051.9961-.6172,1.3184s-.9863.4824-1.7246.4824c-.6387,0-1.1543-.1572-1.5449-.4717-.3906-.3154-.5859-.7314-.5859-1.251,0-.752.4229-1.3057,1.2695-1.6602Zm.9277.5273c-.5898.2314-.8838.5859-.8838,1.0625,0,.2285.0908.418.2705.5674s.3984.2236.6562.2236c.2793,0,.5029-.0723.6729-.2188s.2549-.3398.2549-.5801c0-.4805-.3242-.832-.9707-1.0547Zm.8164-1.9609c0-.2129-.0684-.3838-.2031-.5117-.1367-.127-.3184-.1914-.543-.1914-.2207,0-.4023.0674-.5469.2002-.1465.1338-.2188.3047-.2188.5127,0,.3926.252.6895.7559.8916.5039-.208.7559-.5078.7559-.9014Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'B012',
      5: 'A016',
      6: 'B024-1',
      7: 'B026',
      8: 'C054-1',
      10: 'C057-2',
    },
  },
  {
    id: 'D076-1',
    status: 'available',
    floor: 9,
    building: 'A',
    apartmentNumber: 'D076-1',
    sceneName: 'scene_09krs_D076-1',
    sceneName_future: 'scene_09krs_D076-1_future',
    name: 'D076-1',
    label: 'D76-1',
    lookAt: '-215.35, 0, 120',
    face: 'south',
    area: {
      className: 'cls-13',
      points:
        '277.3809 65.4725 283.0713 127.9216 245.9709 131.2792 241.6505 83.6228 240 65.4167 277.3809 65.4725',
    },
    viewCone: {
      className: 'cls-1',
      pathData:
        'm265.7792,116.3264c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '263.1016',
      cy: '111.8798',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-11',
        d: 'm250.9072,83v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-11',
        d: 'm261.6299,77.3398l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
      {
        className: 'cls-11',
        d: 'm266.4287,76.7637v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
    ],

    relatedApartments: {
      2: 'D060',
      3: 'D062',
      4: 'D065',
      5: 'D068',
      6: 'D071',
      7: 'D074',
      8: 'D077-1',
      10: 'C057-1',
    },
  },
  {
    id: 'D076-2',
    status: 'available',
    floor: 9,
    building: 'A',
    apartmentNumber: 'D076-2',
    sceneName: 'scene_09krs_D076-2',
    sceneName_future: 'scene_09krs_D076-2_future',
    name: 'D076-2',
    label: 'D76-2',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-13',
      points:
        '230.9444 65.4725 240 65.4167 241.6505 83.6228 232.8889 84.3889 230.9444 65.4725',
    },
    viewCone: {
      className: 'cls-9',
      pathData:
        'm239.1056,77.7905c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '236.428',
      cy: '73.3439',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-11',
        d: '',
      },
      {
        className: 'cls-11',
        d: '',
      },
      {
        className: 'cls-11',
        d: '',
      },
    ],

    relatedApartments: {
      2: 'D059',
      3: 'D061',
      4: 'D064',
      5: 'D067',
      6: 'D070',
      7: 'D073',
      8: 'D076',
      10: 'C057-2',
    },
  },
]
